import { render, staticRenderFns } from "./ThemeAttribute.vue?vue&type=template&id=37e2720a"
import script from "./ThemeAttribute.vue?vue&type=script&lang=js"
export * from "./ThemeAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports